import React from 'react'
import { cn } from '../../../lib/utils'

type Props = {
 children: React.ReactNode
 className?: string
 scrollOnMobile?: boolean
}

const AnalyticsKpiRow: React.FC<Props> = ({ children, className, scrollOnMobile = false }) => (
 <div
  className={cn(
   scrollOnMobile
    ? 'flex gap-3 overflow-x-auto pb-1 snap-x snap-mandatory max-sm:[&>*]:min-w-[11rem] sm:grid sm:grid-cols-[repeat(auto-fit,minmax(11rem,1fr))] sm:overflow-visible sm:pb-0'
    : 'grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
   className,
  )}
 >
  {children}
 </div>
)

export default AnalyticsKpiRow
